export class FacebookPixelHandler {
  constructor() {
    this.initialized = false;
    this.pixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID || process.env.REACT_APP_FB_PIXEL_ID;
    this._loadPixelScript();
  }

  _loadPixelScript() {
    if (!window.fbq) {
      // Initialize fbq queue
      window.fbq = window.fbq || function() {
        (window.fbq.q = window.fbq.q || []).push(arguments);
      };
      window._fbq = window._fbq || window.fbq;

      // Load the script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      
      script.onerror = (error) => {
        console.error('Failed to load Facebook Pixel script:', error);
        return false;
      };

      script.onload = () => {
        if (this.pixelId) {
          this.init(this.pixelId);
        }
      };

      document.head.appendChild(script);
    } else if (this.pixelId && !this.initialized) {
      // If fbq is already loaded but not initialized
      this.init(this.pixelId);
    }
  }

  _runWhenFbqAvailable(callback, attempt = 1, maxAttempts = 20) {
    if (window.fbq) {
      callback();
    } else if (attempt < maxAttempts) {
      setTimeout(() => this._runWhenFbqAvailable(callback, attempt + 1, maxAttempts), 50);
    } else {
      console.warn('Facebook Pixel not available after maximum attempts');
    }
  }

  init(pixelId) {
    if (!pixelId) {
      console.warn('No Facebook Pixel ID provided');
      return;
    }
    
    this._runWhenFbqAvailable(() => {
      try {
        window.fbq('init', pixelId);
        window.fbq('track', 'PageView');
        this.initialized = true;
        console.log('Facebook Pixel initialized with ID:', pixelId);
      } catch (error) {
        console.error('Error initializing Facebook Pixel:', error);
      }
    });
  }

  trackPageView() {
    if (!this.initialized) {
      this._checkInitialization();
      return;
    }
    
    this._runWhenFbqAvailable(() => {
      try {
        window.fbq('track', 'PageView', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname
        });
      } catch (error) {
        console.error('Error tracking Facebook Pixel page view:', error);
      }
    });
  }

  trackEvent(eventName, data) {
    if (!this.initialized) {
      this._checkInitialization();
      return;
    }
    
    this._runWhenFbqAvailable(() => {
      try {
        window.fbq('track', eventName, {
          ...data,
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname
        });
      } catch (error) {
        console.error(`Error tracking Facebook Pixel event ${eventName}:`, error);
      }
    });
  }

  _checkInitialization() {
    if (!this.initialized && this.pixelId) {
      this.init(this.pixelId);
    }
  }
} 